// extracted by mini-css-extract-plugin
export var addressInformationBubbleContainer = "_n4-0";
export var buttonContainer = "_n4-3";
export var cancelButton = "_n4-4";
export var headerSection = "_n4-6";
export var headerTitle = "_n4-9";
export var messageSideLeft = "_n4-1";
export var messageSideRight = "_n4-2";
export var orderNumberContainer = "_n4-7";
export var orderNumberLabel = "_n4-8";
export var submitButton = "_n4-5";